@if (required) {
  <div class="weaveFormField">
    <mat-form-field appearance="outline" class="fullWidth">
      @if (label) {
        <mat-label>{{label}}</mat-label>
      }
      <textarea
        matInput
        class="weaveTextareaFlat"
        [disabled]="disabledFlag"
        [placeholder]="placeholder"
        [maxlength]="maxlength"
        [rows]="rows"
        [(ngModel)]='data'
        (blur)="onFocusOut()"
        (keydown.enter)="onFocusOut()"
        (keyup)="onKeyUp($event)"
        (focusin)="startEdit()"
        (keydown.escape)="undo()"
        [attr.name]="id"
        required
        #ctrl="ngModel"
        [id]="id"
        onInput="this.parentNode.dataset.replicatedValue = this.value"
      >
      </textarea>
      @if(ctrl.invalid && ctrl.touched){
        <mat-error>
          {{label || "This field"}} cannot be empty
        </mat-error>
      }
      @if (showError && data === '' && required) {
        <div
          class="weaveFormField_error">
          {{label || "This field"}} cannot be empty
        </div>
      }
    </mat-form-field>
  </div>
}
@if (!required) {
  <div class="weaveFormField">
    <mat-form-field appearance="outline" class="fullWidth" [ngClass]="{'autoHeight': hasAutoHeight}">
      @if (label) {
        <mat-label>{{label}}</mat-label>
      }
      <textarea
        matInput
        class="weaveTextareaFlat"
        [disabled]="disabledFlag"
        [placeholder]="placeholder"
        [maxlength]="maxlength"
        [rows]="rows"
        [(ngModel)]='data'
        (blur)="onFocusOut()"
        (keydown.enter)="onFocusOut()"
        (keyup)="onKeyUp($event)"
        (focusin)="startEdit()"
        (keydown.escape)="undo()"
        [name]="id"
        [id]="id"
        onInput="this.parentNode.dataset.replicatedValue = this.value"
        >
      </textarea>
    </mat-form-field>
  </div>
}

